import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-daily-sales-graph',
  templateUrl: './daily-sales-graph.component.html',
  styleUrls: ['./daily-sales-graph.component.scss']
})
export class DailySalesGraphComponent implements OnInit {
  loader: boolean = false
  _apisub: Subscription

  salesData: any[] = []
  salesGraphData: any
  constructor(private _apiservice: ApiService) { 

    this._apisub = this._apiservice.apiResult.subscribe(resdata =>{
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_COMPOSITE_SALES_DATA_FOR_DASHBOARD){
        this.salesData = []
        if(resdata.result){
          this.salesData = resdata.result
     
          //   this.salesGraphData = {
          //     datasets: [{
          //         label: 'Shop Sales',
          //         data: this.salesData.map(item => {
          //           return item.shopSales
          //       }),
          //         // backgroundColor: "rgb(115 185 243 / 65%)",
          //         borderColor: "#ff0000",
          //         fill: false,
          //         lineTension: 0
          //     },
          //     {
          //       label: 'Home Sales',
          //       data: this.salesData.map(item => {
          //         return item.homeSales
          //     }),
          //       // backgroundColor: "#47a0e8",
          //       borderColor: "#007ee7",
          //       fill: false,
          //       lineTension: 0
        
          //     }],
        
          //     labels: this.salesData.map(item => {
          //       return new Date(item.date).toLocaleDateString()
          //   })
        
          // }
// ---------------------------------------------------------------------------------------------------


          // NEW WAY

          // Flatten the sales data and group by business
          const uniqueBusinesses = new Map<string, { entity_name: string, currency_symbol: string }>();

          this.salesData.forEach(dataItem => {
              const salesArray = JSON.parse(dataItem.sales);
              salesArray.forEach((sale:any) => {
                  uniqueBusinesses.set(sale.entity_hash, { entity_name: sale.entity_name, currency_symbol: sale.currency_symbol });
              });
          });

          // Get all unique dates for the x-axis
          const allDates = [...new Set(this.salesData.map(dataItem => new Date(dataItem.date).toLocaleDateString()))];

          // Prepare datasets for the graph
          const datasets = Array.from(uniqueBusinesses.entries()).map(([entityHash, { entity_name }], index) => {
              return {
                  label: entity_name,
                  data: allDates.map(date => {
                      // Find sales data for this business on the current date
                      const matchingData = this.salesData.find(dataItem => {
                          return new Date(dataItem.date).toLocaleDateString() === date;
                      });

                      if (matchingData) {
                          const salesArray = JSON.parse(matchingData.sales);
                          const businessSales = salesArray.find((sale:any) => sale.entity_hash === entityHash);
                          if (businessSales) {
                              return businessSales.shopSales; // You can change to homeSales or virtualSales as needed
                          }
                      }
                      return 0; // Default to 0 if no data found for this business on this date
                  }),
                  borderColor: this.getDistinctColor(index, uniqueBusinesses.size), // Function to generate random colors for the lines
                  fill: false,
                  lineTension: 0
              };
          });


          // -------------TESTING ZONE---------------
          // const tooltipItem = { datasetIndex: 0, index: 0 };
          // const data = {
          //     datasets: datasets
          // };
          // let ss = this.generateCustomTooltipLabel(tooltipItem,data,allDates,this.salesData)
          // console.log(ss);
          

          // -------------TESTING ZONE---------------
          

                console.log(allDates);
                

                // Assign the data to the graph
                const salesData = this.salesData;
                this.salesGraphData = {
                  datasets,
                  labels: this.formatDateToReadable(allDates),
                  options: {
                    tooltips: {
                        callbacks: {
                            label: function (tooltipItem: any, data: any) {
                                const dataset = data.datasets[tooltipItem.datasetIndex];
                                const value = dataset.data[tooltipItem.index];
                                const entityName = dataset.label;
            
                                // Find matching row for the current date and entity
                                const date = allDates[tooltipItem.index];
                                const matchingData = salesData.find(dataItem =>
                                    new Date(dataItem.date).toLocaleDateString() === date
                                );
            
                                let currencySymbol = '';
                                if (matchingData) {
                                    const parsedData = JSON.parse(matchingData.sales);
                                    const businessData = parsedData.find(
                                        (entry: any) => entry.entity_name === entityName
                                    );
                                    if (businessData) {
                                        currencySymbol = businessData.currency_symbol || ''; // Ensure symbol is present
                                    }
                                }
            
                                // Custom label format with fallback for missing data
                                const formattedValue = value === 0 ? '0' : `${currencySymbol}${value}`;
                                return `${entityName}: ${formattedValue}`;
                            }
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false
                }
                };

                    
        }
        this.loader = false
      }
    })

  }

  ngOnInit(): void {
    this.loader = true
    this._apiservice.getCompositeSalesDataForDashboard()
  }

  getDistinctColor(index: number, total: number) {
    const hue = (index / total) * 360; // Spread hues evenly across 360 degrees
    return `hsl(${hue}, 70%, 50%)`; // Use 70% saturation and 50% lightness for vibrant colors
}

  getRandomColor() {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

generateCustomTooltipLabel(
  tooltipItem: any,
  data: any,
  allDates: string[],
  salesData: { date: string; sales: string }[]
): string {
  console.log(data);
  console.log(salesData);
  
  const dataset = data.datasets[tooltipItem.datasetIndex];
  const value = dataset.data[tooltipItem.index];
  const entityName = dataset.label;

  // Find matching row for the current date and entity
  const date = allDates[tooltipItem.index];
  const matchingData = salesData.find(dataItem =>
      new Date(dataItem.date).toLocaleDateString() === date
  );

  let currencySymbol = '';
  if (matchingData) {
      const parsedData = JSON.parse(matchingData.sales);
      const businessData = parsedData.find((entry: any) => entry.entity_name === entityName);
      if (businessData) {
          currencySymbol = businessData.currency_symbol; // Use the provided currency symbol
      }
  }

  // Custom label format
  return `${entityName}: ${currencySymbol}${value}`;
}

formatDates(dateArray:any) {
  return dateArray.map((dateString:any) => {
      const date = new Date(dateString);
      const day = date.getDate();
      const month = date.toLocaleString('default', { month: 'short' }); // Get abbreviated month name
      return `${day} ${month}`;
  });
}

formatDateToReadable(dateArray: any[]): string[] {
  console.log("dates", dateArray);

  return dateArray.map((dateString: string) => {
    // Parse DD/MM/YYYY format manually
    const [day, month, year] = dateString.split('/').map(Number);

    // Create a valid Date object (month is zero-based in JavaScript)
    const parsedDate = new Date(year, month - 1, day);

    // Check if the parsedDate is valid
    if (isNaN(parsedDate.getTime())) {
      console.error(`Invalid date format: ${dateString}`);
      return "Invalid Date"; // Or handle the error as needed
    }

    // Format the valid date as 'dd MMM'
    return formatDate(parsedDate, 'dd MMM', 'en-US');
  });
}

}
